import { Link } from "@remix-run/react";
import { c } from "node_modules/vite/dist/node/types.d-AKzkD8vd";
import { ReactNode } from "react";

export default function Index() {
  return (
    <div className="flex h-full w-full flex-col items-center bg-[#E3DACC]">
      <div className="text-bold mt-20 font-FKScreamer text-[100px] uppercase">
        Skilmálar
      </div>
      <div className="mx-6 mt-20 flex max-w-[600px] flex-col items-center text-center text-2xl font-semibold sm:mx-10">
        <Header>Nola</Header>
        <Paragraph>
          Pöntun er afgreidd þegar greiðsla hefur borist. Um leið og greiðsla
          berst er kaupanda send staðfesting í tölvupósti. Réttur er áskilinn
          til að staðfesta pantanir símleiðis í undantekningartilfellum. Hægt er
          að velja að sækja pöntun eða fá sent. Allar sendar pantanir fara með
          Póstinum & Dropp og gilda afhendingar-, ábyrgðar og flutningsskilmálar
          þeirra um afhendingu vörunnar. Nola ber samkvæmt þessu enga ábyrgð á
          tjóni sem kann að verða á vöru í flutningi. Verði vara fyrir tjóni frá
          því að að hún er send frá Nola til viðkomandi er tjónið á ábyrgð
          kaupanda. Einnig er hægt að sækja pantanir til okkar í verslun okkar í
          Ármúla 38. Opnunartími er mánudaga-föstudaga 10-17, laugardaga 11-17,
          lokað á sunnudögum.
        </Paragraph>
        <Header>Afhendingartími</Header>
        <Paragraph>
          Afhendingartími innanlands er að jafnaði samdægurs til 1-2 virkir
          dagar eftir að pöntun berst og greiðsla hefur átt sér stað. Gætið að
          því að fylla út réttar upplýsingar um heimilisfang við pöntun til að
          tryggja rétta afhendingu. Einnig er hægt að sækja pöntunina í verslun
          okkar á eftirfarandi tímum: mánudaga-föstudaga 10-17, laugardaga
          11-17. Lokað á sunnudögum.
        </Paragraph>
        <Header>SENDINGARSKOSTNAÐUR</Header>
        <Paragraph>
          Sendingarkostnaður bætist við pöntun áður en greiðsla fer fram.
          Vefverslun okkar er beintengd við póststoð Póstsins & Dropp og
          reiknast því sendingarkostnaður miðað við verðskrá þeirra. Enginn
          sendingarkostnaður er fyrir pantanir sem fara yfir 20.000 krónur. Nola
          sendir um allt land.
        </Paragraph>
        <Header>Verð</Header>
        <Paragraph>
          24% VSK er innifalinn í verði vörunnar og reikningar eru gefnir út með
          VSK. Öll verð eru birt með fyrirvara um myndbrengl eða prentvillur og
          áskilur Nola sér rétt til að hætta við viðskipti hafi rangt verð verið
          gefið upp. Ef varan er ekki til á lager látum við þig vita og
          endurgreiðum hafi greiðsla farið fram. Vinsamlegast athugið að verð á
          netinu getur breyst án fyrirvara.
        </Paragraph>
        <Header>Vörur</Header>
        <Paragraph>
          Ef ljósmyndir og eða litir eru óskýrir á vefsíðu, vinsamlegast sendið
          þá beiðni um frekari lýsingu á vöru á netfangið nola@nola.is
        </Paragraph>
        <Header>MEÐFERÐ PERSÓNUUPPLÝSINGA</Header>
        <Paragraph>
          <Link to="/personuverndarstefna">SJÁ NÁNAR HÉR</Link>
        </Paragraph>
        <Header>Skilafrestur</Header>
        <Paragraph>
          Kaupandi hefur 14 daga til að hætta við kaupin að því tilskildu að
          hann hafi ekki notað vöruna, henni sé skilað í góðu lagi í óuppteknum
          upprunalegum umbúðum. Ef vara er innsigluð má ekki rjúfa innsiglið.
          Fresturinn byrjar að líða þegar varan er afhent skráðum viðtakanda.
          Ekki er hægt að skila eða skipta vöru án kvittunar. Gefin er
          inneignarnóta ef ofangreind skilyrði eru uppfyllt og eftir að varan er
          móttekin. Flutnings- og póstburðargjöld eru ekki endurgreidd.
          Vinsamlegast hafið samband við okkur í síma: 537-1877 eða sendið okkur
          tölvupóst á order@nola.is ef spurningar vakna. Ekki er hægt að skila
          eða skipta vörum sem ekki er hægt að sanna að hafi verið opnaðar, td
          gloss, ilmir, maskarar og naglalökk.
        </Paragraph>
        <Header>Greiðslur</Header>
        <Paragraph>
          Við bjóðum upp á nokkra greiðslumöguleika: Greiðslukort, Aur og
          Netgíró. Þú getur greitt fyrir vöruna í vefversluninni með kreditkorti
          í gegnum örugga greiðslugátt Teya. Netgíró bíður upp á kortalaus
          viðskipti á netinu. Þú þarft að vera með aðgang hjá Netgíró til þess
          að nýta þér þjónustuna, fyrir þá sem hafa hann ekki er hægt að skrá
          sig hérna. Þegar þú greiðir með Netgíró þarftu aðeins að skrá inn
          kennitölu og lykilorð og þá er pöntunin frágengin. Reikningur stofnast
          á viðskiptavin í heimabanka sem greiða þarf innan 14 daga, vaxtalaust.
          Einnig er hægt að velja að greiða með raðgreiðslum og það er mögulegt
          á að dreifa því á 2-12 mánuði. Aur bíður uppá einfaldar greiðslur þar
          sem greitt er með því að gefa upp símanúmer.
        </Paragraph>
        <Header>Trúnaður</Header>
        <Paragraph>
          Seljandi heitir kaupanda fullum trúnaði um allar þær upplýsingar sem
          kaupandi gefur upp í tengslum við viðskiptin. Upplýsingar verða ekki
          afhentar þriðja aðila undir neinum kringumstæðum.
        </Paragraph>
      </div>
    </div>
  );
}

const Header = ({ children }: { children: ReactNode }) => (
  <div className="mb-4 mt-10 font-FKScreamer text-[48px] font-semibold leading-[48px]">
    {children}
  </div>
);
const Paragraph = ({ children }: { children: ReactNode }) => (
  <div className="my-2">{children}</div>
);
